export enum TIcons {
  CHEVRON_RIGHT = '/images/chevron-right.svg',
  EDIT = 'edit',
  DONE = 'done',
  CLOSE = 'close',
  CHANGE_CIRCLE = 'change_circle',
  ADD = 'add',
  WHISTLE = 'sports',
}

export const ICONS = [
  TIcons.EDIT,
  TIcons.DONE,
  TIcons.CLOSE,
  TIcons.CHANGE_CIRCLE,
  TIcons.ADD,
  TIcons.WHISTLE,
];
